var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyResult(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.038,
    height: 32.75,
    viewBox: "0 0 33.038 32.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27949",
    "data-name": "Group 27949",
    transform: "translate(-151.486 -307.25)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Path",
    cx: 10.475,
    cy: 10.475,
    rx: 10.475,
    ry: 10.475,
    transform: "translate(152.236 308)",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line",
    y1: 3.427,
    transform: "translate(170.536 326.011) rotate(-45)",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27948",
    "data-name": "Group 27948",
    transform: "matrix(0.999, 0.035, -0.035, 0.999, 159.296, 314.928)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line-2",
    "data-name": "Line",
    x1: 6.854,
    y2: 6.854,
    transform: "translate(0 0.239) rotate(-2)",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line-3",
    "data-name": "Line",
    x2: 6.854,
    y2: 6.854,
    transform: "translate(0 0.239) rotate(-2)",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3099",
    "data-name": "Rectangle 3099",
    transform: "translate(171.196 330.307) rotate(-45)",
    fill: "none",
    stroke: "#dedede",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H5.141a0,0,0,0,1,0,0V11.138a2.57,2.57,0,0,1-2.57,2.57h0A2.57,2.57,0,0,1,0,11.138V0A0,0,0,0,1,0,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75.75H4.391a0,0,0,0,1,0,0V11.138a1.82,1.82,0,0,1-1.82,1.82h0a1.82,1.82,0,0,1-1.82-1.82V.75a0,0,0,0,1,0,0Z",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyResult);
export default __webpack_public_path__ + "static/media/empty-result.2844c45b557e19bca9721e82216c11e9.svg";
export { ForwardRef as ReactComponent };